import React, { useEffect, useState } from 'react';
import './DateRangeFilterModal.css';

const DateRangeFilterModal = ({ isOpen, onClose, onApply, initialRange = {} }) => {
  const [baslangic, setBaslangic] = useState(initialRange.baslangicTarihi || '');
  const [bitis, setBitis] = useState(initialRange.bitisTarihi || '');

  useEffect(() => {
    if (isOpen) {
      setBaslangic(initialRange.baslangicTarihi || '');
      setBitis(initialRange.bitisTarihi || '');
    }
  }, [isOpen, initialRange.baslangicTarihi, initialRange.bitisTarihi]);

  if (!isOpen) return null;

  const handleApply = () => {
    if (baslangic && bitis && baslangic > bitis) {
      window.showNotification?.('error', 'Başlangıç tarihi bitiş tarihinden sonra olamaz.');
      return;
    }
    onApply({
      baslangicTarihi: baslangic || undefined,
      bitisTarihi: bitis || undefined,
    });
    onClose();
  };

  const handleClear = () => {
    setBaslangic('');
    setBitis('');
    onApply({});
    onClose();
  };

  const hasFilter = Boolean(baslangic || bitis);

  return (
    <div className="modal-overlay" onClick={onClose} role="presentation">
      <div
        className="modal-content date-range-filter-modal"
        onClick={(e) => e.stopPropagation()}
        role="dialog"
        aria-labelledby="date-range-filter-title"
      >
        <div className="modal-header">
          <h2 id="date-range-filter-title">Tarih Filtresi</h2>
          <button type="button" className="modal-close-btn" onClick={onClose} aria-label="Kapat">
            <i className="fas fa-times" aria-hidden="true" />
          </button>
        </div>
        <div className="modal-body">
          <div className="form-group">
            <label htmlFor="filter-baslangic">Başlangıç Tarihi</label>
            <input
              id="filter-baslangic"
              type="date"
              value={baslangic}
              onChange={(e) => setBaslangic(e.target.value)}
            />
          </div>
          <div className="form-group">
            <label htmlFor="filter-bitis">Bitiş Tarihi</label>
            <input
              id="filter-bitis"
              type="date"
              value={bitis}
              onChange={(e) => setBitis(e.target.value)}
            />
          </div>
          {hasFilter && (
            <p className="date-range-filter-hint">Seçili aralık uygulanacak.</p>
          )}
        </div>
        <div className="modal-footer">
          <button type="button" className="secondary-btn" onClick={handleClear}>
            Temizle
          </button>
          <button type="button" className="secondary-btn" onClick={onClose}>
            İptal
          </button>
          <button type="button" className="primary-btn" onClick={handleApply}>
            Uygula
          </button>
        </div>
      </div>
    </div>
  );
};

export default DateRangeFilterModal;
